<template>
  <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
    <transition mode="out-in" name="fade">
      <div
        @click="showDetails = false"
        class="fixed h-full w-full details"
        style="background: #fff; top: 0; left: 0; z-index: 10;"
        v-show="this.showDetails && selectedRoomDetails != 'undefined'"
      ></div>
    </transition>
    <transition mode="out-in" name="slide-right">
      <div
        class="fixed h-full"
        style="width: 704px; background: #000; top: 0; right: 0; z-index: 11;"
        v-if="this.showDetails && selectedRoomDetails != 'undefined'"
      >
        <h3
          style="position: relative; margin-top: 423px; padding-left: 106px; font-size: 32px; font-family: Georgia"
        >
          <a @click="showDetails = false" class="close" href="#"></a>
          <span v-if="selectedRoomDetails.number != null"
            >{{ selectedRoomDetails.number }}.
          </span>
          <span v-if="selectedRoomDetails.details.lived != ''">{{
            selectedRoomDetails.name
          }}</span
          ><span style="color: black" v-else>.</span>
        </h3>
        <div
          style="background: rgba(255,255,255,0.2); margin-top: 70px; text-align: center;"
        >
          <img
            :src="
              require('../assets/images/maps/' +
                this.config.name +
                '/' +
                this.selectedRoomDetails.details.image)
            "
            style="margin: 0 auto; height:420px;"
            v-if="selectedRoomDetails.details.image != undefined"
          />
        </div>
        <div style="margin: 70px 48px;">
          <h4
            style="font-family: Georgia; font-size: 24px; text-transform: uppercase; padding-bottom: 16px"
          >
            {{ selectedRoomDetails.name }}
            <span
              v-if="
                !(
                  selectedRoomDetails.details.lived == '' ||
                  selectedRoomDetails.details.lived == null
                )
              "
              >({{ selectedRoomDetails.details.lived }})</span
            >
          </h4>
          <p
            style="font-size: 22px; line-height: 1.47; text-transform: none; font-weight: 300"
            v-html="selectedRoomDetails.details.description"
          ></p>
        </div>
      </div>
    </transition>

    <div @click.stop="selectRoom(null, null)" class="flex">
      <div
        :style="{ height: '1229px', width: '636px' }"
        class=""
        style="overflow: hidden; padding-left: 120px"
        v-hammer:tap="reset"
      >
        <div style="position: relative;">
          <div
            :id="'map' + this.config.name"
            :style="{
              width: this.config.mapWidth + 'px',
              height: this.config.mapHeight + 'px'
            }"
            style="-webkit-transition-property: transform;
                                transition-property: transform;
                                -webkit-transition: 100ms ease-out;
                                transition: 100ms ease-out; position: absolute; top: 0; left: 0"
            v-hammer:pan="onMove"
            v-hammer:panend="onEnd"
            v-hammer:pinch="onMove"
            v-hammer:pinchend="onEnd"
          >
            <div
              :key="index"
              :style="{
                width: image.width + 'px',
                height: image.height + 'px',
                left: image.x + 'px',
                top: image.y + 'px',
                filter:
                  selectedRoom != image.name &&
                  (selectedCategory == image.category ||
                    selectedCategory == null)
                    ? 'opacity(0.6)'
                    : selectedRoom == image.name
                    ? 'opacity(1)'
                    : 'opacity(0)',
                backgroundImage:
                  image.selectionOnMap == null
                    ? 'none'
                    : image.type == 'graphics'
                    ? 'linear-gradient(265deg, #32c5ff, #b620e0 49%, #f7b500)'
                    : 'url(' +
                      require('../assets/images/maps/' + image.selectionOnMap) +
                      ')'
              }"
              @click.stop="selectRoom(image.name, image.category)"
              class="absolute"
              v-for="(image, index) in this.images"
            ></div>
            <img
              :src="
                require('../assets/images/maps/' +
                  this.config.name +
                  '/' +
                  this.config.mapSource)
              "
              :style="{
                width: this.config.mapWidth + 'px',
                height: this.config.mapHeight + 'px'
              }"
              alt=""
              style="position: absolute; top: 0; left: 0; "
            />
            <div
              :style="{
                top: this.config.pin.y + 'px',
                left: this.config.pin.x + 'px'
              }"
              class="absolute"
              v-if="config.pin != undefined"
            >
              <img
                :src="require('../assets/images/maps/pin.svg')"
                class="animated bounce delay-1s"
              />
            </div>
            <div
              :key="image.name"
              :style="{
                width: image.width + 'px',
                height: image.height + 'px',
                left: image.x + 'px',
                top: image.y + 'px',
                opacity:
                  selectedCategory == image.category || selectedCategory == null
                    ? 1
                    : 0
              }"
              @click.stop="selectRoom(image.name, image.category)"
              class="absolute"
              v-for="image in this.images"
            >
              <div
                :style="{
                  width: image.width + 'px',
                  height: image.height + 'px',
                  lineHeight: image.height + 'px',
                  zIndex: selectedRoom == image.name ? 10 : 0,
                  fontWeight: selectedRoom == image.name ? 'bold' : 'normal'
                }"
                v-show="image.number !== null"
                class="room"
              >
                {{ image.number }}
              </div>
              <div
                :class="{
                  right: image.x <= 195 && image.y < 960 && image.y > 124,
                  top: image.y >= 960
                }"
                :style="{ zIndex: selectedRoom == image.name ? 10 : 1 }"
                class="tooltip"
                v-show="selectedRoom == image.name"
              >
                <div class="flex">
                  <span style="" v-if="image.number != null"
                    >{{ image.number }}.
                  </span>
                  {{ image.name }} <br />
                  {{ image.person }}
                </div>
                <a
                  @click="showDetails = true"
                  v-if="selectedRoomDetails.details != undefined"
                  >Show Details</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.stop="selectRoom(null, null)"
        style="padding-left: 5px; width: 324px; height: 1229px; padding-bottom: 200px; overflow-y: scroll"
      >
        <ul>
          <li
            :key="category.name"
            :style="{
              fontWeight: category.name == selectedCategory ? 'bold' : 'normal'
            }"
            class="relative pl-5"
            style="margin-bottom: 40px; font-size: 20px"
            v-for="category in config.roomList"
          >
            <div
              :class="{ active: category.name == selectedCategory }"
              @click.stop="selectCategory(category.name)"
              class="menu-arrow"
            ></div>
            <span @click.stop="selectCategory(category.name)">
              {{ category.name }}
            </span>
            <ul v-show="category.name == selectedCategory">
              <li
                :key="room.name"
                :style="{
                  fontWeight: room.name == selectedRoom ? 'bold' : 300
                }"
                @click.stop="selectRoom(room.name, category.name)"
                class="flex"
                style="text-transform: none; font-size: 18px; margin-top: 24px;"
                v-for="room in category.rooms"
              >
                <span
                  style="display: block; width: 45px; min-width: 45px; padding-right: 8px; text-align: center"
                  v-show="room.number !== null"
                  >{{ room.number }}.</span
                >
                <div>
                  {{ room.name }} <br />
                  {{ room.person }}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vmap",
  props: {
    config: Object
  },
  data: function() {
    return {
      showDetails: false,
      selectedCategory: null,
      selectedRoom: null,
      transform: {
        translate: { x: 0, y: 0 },
        scale: 1
      },
      maxScale: 2,
      minScale: 1
    };
  },
  methods: {
    selectCategory: function(name) {
      if (this.selectedCategory == name) {
        this.selectedCategory = null;
        this.selectedRoom = null;
      } else {
        this.selectedRoom = null;
        this.selectedCategory = name;
      }
    },
    selectRoom: function(name, categoryName) {
      this.selectedRoom = name;
      this.selectedCategory = categoryName;
    },
    onMove: function(ev) {
      document.getElementById("map" + this.config.name).style.transform =
        "translate(" +
        (this.transform.translate.x + ev.deltaX) +
        "px," +
        (this.transform.translate.y + ev.deltaY) +
        "px) scale(" +
        this.transform.scale * ev.scale +
        ")";
    },
    onEnd: function(ev) {
      this.transform.scale =
        this.transform.scale * ev.scale < this.maxScale
          ? this.transform.scale * ev.scale < this.minScale
            ? this.minScale
            : this.transform.scale * ev.scale
          : this.maxScale;
      this.transform.translate = {
        x:
          Math.abs(this.transform.translate.x + ev.deltaX) > this.maxX
            ? ((this.transform.translate.x + ev.deltaX) /
                Math.abs(this.transform.translate.x + ev.deltaX)) *
              this.maxX
            : this.transform.translate.x + ev.deltaX,
        y:
          Math.abs(this.transform.translate.y + ev.deltaY) > this.maxY
            ? ((this.transform.translate.y + ev.deltaY) /
                Math.abs(this.transform.translate.y + ev.deltaY)) *
              this.maxY
            : this.transform.translate.y + ev.deltaY
      };
      document.getElementById("map" + this.config.name).style.transform =
        "translate(" +
        this.transform.translate.x +
        "px," +
        this.transform.translate.y +
        "px) scale(" +
        this.transform.scale +
        ")";
    },
    reset: function() {
      this.transform = {
        translate: { x: 0, y: 0 },
        scale: 1
      };
      document.getElementById("map" + this.config.name).style.transform =
        "translate(" +
        this.transform.translate.x +
        "px," +
        this.transform.translate.y +
        "px) scale(" +
        this.transform.scale +
        ")";
    },
    getSelectedRoomDetails() {
      if (this.selectedRoom == null || this.selectedCategory == null) return {};

      let self = this;

      return this.config.roomList
        .filter(function(value) {
          return value.name == self.selectedCategory;
        })[0]
        .rooms.filter(function(value) {
          return value.name == self.selectedRoom;
        })[0];
    }
  },
  computed: {
    maxX: function() {
      return this.transform.scale * 250;
    },
    maxY: function() {
      return this.transform.scale * 700;
    },
    images: function() {
      let images = [];
      let self = this;
      this.config.roomList.forEach(function(category) {
        category.rooms.forEach(function(room) {
          images.push({
            category: category.name,
            type:
              category.name == "Wall Graphics" && room.bg == undefined
                ? "graphics"
                : "normal",
            name: room.name,
            person: room.person,
            number: room.number,
            selectionOnMap: room.selectionOnMap
              ? self.config.name + "/" + room.selectionOnMap
              : null,
            width: room.width,
            height: room.height,
            x: room.x,
            y: room.y
          });
        });
      });
      return images;
    },
    selectedRoomDetails: function() {
      return this.getSelectedRoomDetails();
    }
  }
};
</script>

<style scoped>
.room {
  position: absolute;
  color: #fff;
  font-size: 12px;
  text-align: center;
  top: 0;
  left: 0;
}

.details {
  opacity: 0.17;
}

.tooltip {
  text-transform: none;
  background-color: #fff;
  padding: 24px;
  position: absolute;
  top: calc(100% + 10px);
  right: calc(20% - 40px);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  min-width: 180px;
  max-width: 240px;
}

.tooltip a {
  display: block;
  margin-top: 24px;
  width: 100%;
  padding: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.88;
  color: #000000;
  background: white;
  border: 1px solid #000;
}

.tooltip:after {
  top: -19px;
  right: 25%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}

.tooltip.right {
  top: -29px;
  left: calc(100% + 15px);
}

.tooltip.right:after {
  top: 20px;
  left: -9px;
  transform: rotate(-90deg);
}

.tooltip.top {
  top: auto;
  bottom: calc(100% + 15px);
  left: 5px;
}

.tooltip.top:after {
  left: 20px;
  top: auto;
  bottom: -19px;
  transform: rotate(180deg);
}

.menu-arrow {
  width: 20px;
  height: 20px;
  left: -9px;
  top: 5px;
  transform: rotate(45deg);
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  position: absolute;
  transform-origin: 50% 50%;
  transition: all 300ms ease;
}

.menu-arrow.active {
  transform: rotate(-45deg);
  top: 9px;
  left: 0;
}

.slide-right-enter {
  transform: translateX(734px);
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.5s ease;
}

.slide-right-leave-to {
  transform: translateX(734px);
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-leave-to {
  opacity: 0;
}
</style>
